<footer class="footer gradient--royal">
  <slot />
</footer>

<style lang="scss">
  .footer {
    position: relative;
    color: rgb(var(--white));
  }
</style>
